<template>
	<div>
		<TilteParallax
			v-if="$vuetify.breakpoint.mdAndUp"
			image="https://apps.pinturasacuario.mx/assets/store/images/customer/article.jpg"
		>
			<template v-slot:title v-if="article.category">
				{{ article.category.name }}
			</template>

			<template
				v-if="article.code && article.description"
				v-slot:subtitle
			>
				{{ `${article.code} - ${article.description}` }}
			</template>
		</TilteParallax>

		<v-container fluid>
			<v-row justify="center">
				<v-col
					cols="12"
					md="10"
					lg="11"
					:class="[{ 'pa-0': $vuetify.breakpoint.smAndDown }]"
				>
					<v-card outlined :loading="ui.geting">
						<v-card-text
							:class="{ 'pa-0': $vuetify.breakpoint.smAndDown }"
						>
							<v-row justify="center">
								<v-col
									md="1"
									class="d-none d-md-flex flex-column mt-3 carousel-images-container"
								>
									<v-hover
										v-slot="{ hover }"
										v-for="(url, key) in article.images"
									>
										<v-card
											:elevation="hover ? 2 : 0"
											:class="[
												'mb-2',
												'pa-0',
												'carousel-image',
												{ 'on-hover': hover },
												{
													'slide-active':
														ui.slideActive === key,
												},
											]"
											color="#fff"
											outlined
											@click="setSlideActive(key)"
										>
											<v-card-text class="pa-0">
												<v-row>
													<v-col
														cols="12"
														class="d-flex justify-center align-center pa-1"
													>
														<img
															:src="url"
															alt=""
														/>
													</v-col>
												</v-row>
											</v-card-text>
										</v-card>
									</v-hover>
								</v-col>

								<v-col cols="12" md="7" class="pl-1 pr-1">
									<v-carousel
										cycle
										:height="
											$vuetify.breakpoint.smAndDown
												? '400px'
												: '80vh'
										"
										:show-arrows="
											article.images.length > 1
												? true
												: false
										"
										v-model="ui.slideActive"
									>
										<template v-if="article.images">
											<template
												v-if="article.images.length"
											>
												<v-carousel-item
													v-for="(url,
													i) in article.images"
													:key="i"
												>
													<v-sheet
														color="#fff"
														height="100%"
													>
														<v-row
															class="fill-height"
															align="center"
															justify="center"
														>
															<img
																:src="url"
																alt=""
																height="90%"
															/>
														</v-row>
													</v-sheet>
												</v-carousel-item>
											</template>

											<template v-else>
												<v-carousel-item>
													<v-sheet
														color="#eee"
														height="100%"
													>
														<v-row
															class="fill-height"
															align="center"
															justify="center"
														>
															<v-col
																cols="12"
																class="d-flex justify-center text-center black--text"
															>
																Sin imagenes
																para mostrar.
															</v-col>
														</v-row>
													</v-sheet>
												</v-carousel-item>
											</template>
										</template>
									</v-carousel>
								</v-col>

								<v-col
									cols="12"
									md="4"
									:class="[
										{
											'pa-5':
												$vuetify.breakpoint.smAndDown,
										},
									]"
								>
									<v-row>
										<!-- Only => Md and Up -->
										<template
											v-if="
												article.price ||
													article.description
											"
										>
											<v-col
												cols="12"
												class="d-flex flex-column"
											>
												<!-- <v-alert
													color="success"
													text
													icon="mdi-trophy"
													border="left"
												>
													<div
														class="d-flex flex-column"
													>
														1er lugar
														<small>
															PROFECO en su
															edición #521 julio /
															2020.
														</small>
													</div>
												</v-alert> -->

												<h2 class="mt-3 mb-1">
													{{ article.description }}
												</h2>

												<!-- Precio unitario -->
												<h3>
													Precio unitario:
													<strong>
														{{
															`${priceFormat(
																Price
															)} MXN`
														}}
													</strong>
												</h3>

												<div
													class="d-flex flex-column mt-5"
												>
													<div
														class="d-flex align-center"
													>
														<h1 class="black--text">
															{{
																`${priceFormat(
																	Amount
																)} MXN`
															}}
														</h1>

														<template
															v-if="HasDiscount"
														>
															<v-chip
																small
																color="success"
																class="ml-1"
															>
																{{
																	`-${article.discount}% OFF`
																}}
															</v-chip>
														</template>
													</div>

													<template
														v-if="HasDiscount"
													>
														<h3
															style="text-decoration: line-through;"
															class="ma-0"
														>
															{{
																`${priceFormat(
																	article.price
																)} MXN`
															}}
														</h3>
													</template>
												</div>

												<AmountIputGroup
													class="mt-7 mb-2"
													:article="article"
													:amount="layout.amount"
													@change="change"
												></AmountIputGroup>

												<v-btn
													class="mt-4"
													color="primary"
													block
													:loading="ui.geting"
													large
													@click="cartArticlePush()"
												>
													agregar al carrito
													<v-icon class="ml-2">
														mdi-cart
													</v-icon>
												</v-btn>
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													SKU:
												</h3>
												{{ article.code }}
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													Color:
												</h3>
												<div
													class="d-flex align-center"
												>
													<template
														v-if="article.color"
													>
														<v-avatar
															size="20"
															:color="
																article.color
																	.hex
															"
															class="mr-2"
														/>
														{{ article.color.name }}
													</template>
												</div>
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													Contenido neto:
												</h3>
												{{ NetContent }}
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-cube
													</v-icon> -->
													Piezas por caja:
												</h3>

												{{
													article.box_capacity
														? `${article.box_capacity} pz por caja`
														: "NA"
												}}
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-weight-kilogram
													</v-icon> -->
													Peso:
												</h3>
												{{ Weight }}
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-star-circle
													</v-icon> -->
													Calidad:
												</h3>
												<Quality
													:quality="article.quality"
												></Quality>
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-brush
													</v-icon> -->
													Acabado:
												</h3>

												<template
													v-if="
														article.type_of_finish
													"
												>
													{{
														article.type_of_finish
															.name
													}}
												</template>
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-format-paint
													</v-icon> -->
													Rendimiento teórico:
												</h3>
												<!-- {{ `9 mt&sup2;/Lt` }} -->
											</v-col>

											<v-col
												cols="6"
												class="d-flex flex-column"
											>
												<h3>
													<!-- <v-icon>
														mdi-timer
													</v-icon> -->
													Tiempo de secado:
												</h3>
												<!-- {{ `30 min` }} -->
											</v-col>
										</template>

										<template v-else>
											<v-col cols="12">
												<v-skeleton-loader
													type="article, article, actions, article"
												></v-skeleton-loader>
											</v-col>
										</template>
									</v-row>
								</v-col>
							</v-row>

							<v-row justify="center">
								<v-col cols="12" class="pb-0">
									<h2>Detalles del producto:</h2>
								</v-col>
								<v-col cols="12" class="pt-0 pb-0">
									<v-row align="center">
										<v-col
											md="1"
											cols="12"
											:class="[
												'pa-0',
												'd-flex',
												'justify-center',
												'align-center',
												{
													'pt-3':
														$vuetify.breakpoint
															.smAndDown,
												},
											]"
										>
											<v-item-group
												v-model="ui.window"
												:class="[
													'd-flex',
													{
														'flex-column':
															$vuetify.breakpoint
																.mdAndUp,
													},
												]"
											>
												<v-item
													v-for="n in length"
													:key="n"
													v-slot="{ active, toggle }"
												>
													<v-btn
														icon
														:input-value="active"
														@click="toggle"
													>
														<v-icon
															>mdi-record</v-icon
														>
													</v-btn>
												</v-item>
											</v-item-group>
										</v-col>

										<v-col
											cols="12"
											md="11"
											:class="{
												'pt-0':
													$vuetify.breakpoint
														.smAndDown,
											}"
										>
											<v-window
												v-model="ui.window"
												:vertical="
													$vuetify.breakpoint.mdAndUp
												"
											>
												<v-window-item
													v-for="n in length"
													:key="n"
												>
													<v-card flat>
														<v-card-text>
															<v-row
																align="center"
															>
																<v-col
																	cols="12"
																	class="d-flex align-center"
																>
																	<v-avatar
																		color="#0078D7"
																	>
																		<v-icon
																			class="white--text"
																		>
																			mdi-format-paint
																		</v-icon>
																	</v-avatar>
																	<strong
																		class="title ml-3"
																	>
																		Descripción
																		y
																		caracteristicas:
																	</strong>
																</v-col>
															</v-row>

															<v-row>
																<v-col
																	cols="12"
																>
																	<p>
																		Es una
																		pinturaacrílica
																		modificada
																		de
																		última
																		generación,
																		creada
																		específicamente
																		para
																		realzar
																		la
																		belleza
																		de
																		cualquier
																		área con
																		un fino
																		acabado
																		mate.
																		Puede
																		ser
																		aplicada
																		en
																		superficies
																		de
																		cemento,
																		yeso,
																		ladrillo,
																		madera,
																		entre
																		otras;
																		contribuyendo
																		al medio
																		ambiente
																		y
																		cuidando
																		tu salud
																		debido a
																		su
																		formulación
																		libre de
																		plomo.
																		Características:
																		Mayor
																		Lavabilidad
																		Ecológica
																		Duración
																		inigualable.
																	</p>
																</v-col>

																<v-col
																	cols="12"
																	class="d-flex justify-space-around flex-wrap"
																>
																	<v-chip
																		v-for="characteristic in characteristics"
																		class="ma-1"
																		color="#eee"
																	>
																		{{
																			characteristic
																		}}
																		<v-icon
																			class="ml-1  green--text"
																		>
																			mdi-checkbox-marked-circle-outline
																		</v-icon>
																	</v-chip>
																</v-col>
															</v-row>
														</v-card-text>
													</v-card>
												</v-window-item>
											</v-window>
										</v-col>
									</v-row>
								</v-col>
							</v-row>

							<v-row justify="center">
								<v-col cols="12">
									<v-row>
										<v-col
											cols="12"
											class="d-flex justify-start"
										>
											<span class="category-title">
												Artículos relacionados
											</span>
										</v-col>

										<v-col cols="12">
											<!-- Slide Group -->
											<SlideGroup
												:articles="
													sliders.articlesRelated
												"
											></SlideGroup>
										</v-col>
									</v-row>
								</v-col>

								<v-col cols="12">
									<v-row>
										<v-col
											cols="12"
											v-for="category in largeCategories"
										>
											<CategorySimpleLage
												:category="category"
											></CategorySimpleLage>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import CategorySimpleLage from "@/components/Category/LargeCard";
import AmountIputGroup from "@/components/AmountIputGroup";
import SlideGroup from "@/components/Carousel/SlideGroup";
import TilteParallax from "@/components/TilteParallax";
import Quality from "@/components/Article/Quality";
import Article from "@/clas/Article";
import { EventBus } from "@/main";
import axios from "axios";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
import { V } from "@/main";

export default {
	components: {
		Quality,
		SlideGroup,
		TilteParallax,
		AmountIputGroup,
		CategorySimpleLage,
	},

	data() {
		return {
			v: V,

			characteristics: [
				"Única con tecnología antihongos",
				"Excelente rendimiento",
				"Duración 5 Años",
				"Acabado mate",
				"Fácil integración, no produce grumos",
			],

			article: {
				images: [],
			},

			largeCategories: [
				{
					name: "Impermeabilizantes",
					description:
						"Acriterm el impermeabilizante elastomérico formulado a base de resinas estiren-acrílicas de la más alta calidad.",
					color: "orange",
				},
			],

			layout: {
				amount: 1,
			},

			length: 3,

			window: 0,

			sliders: {
				articlesRelated: [],
			},

			ui: {
				window: 0,
				valid: true,
				geting: true,
				slideActive: 0,
			},
		};
	},

	created() {
		this.get();

		let article = this.$store.getters.getArticles.find(
			(article) => article.id === this.$route.params.id
		);

		if (article) {
			this.article = article;
		}
	},

	methods: {
		async get() {
			try {
				this.ui.geting = true;

				let endpoint = `${process.env.VUE_APP_API_SERVER}/store/article/${this.$route.params.id}`;

				if (this.$store.state.authenticated) {
					endpoint = `${process.env.VUE_APP_API_SERVER}/auth/customer/${this.account.user.customer.id}/article/${this.$route.params.id}`;
				}

				let resp = await axios.get(endpoint, {
					headers: {
						Authorization: `Bearer ${this.account.token}`,
					},
				});

				this.article = {
					...resp.data.data,
					discount: resp.data.data.pivot
						? resp.data.data.pivot.discount
						: resp.data.data.discount,
					price: resp.data.data.pivot
						? resp.data.data.pivot.price
						: resp.data.data.price,
				};

				this.setArticlesRelated();
			} catch (error) {
				EventBus.$emit("Error", { error: error, errorsShow: true });
			} finally {
				this.ui.geting = false;
			}
		},

		change(article, amount) {
			this.layout.amount = amount;
		},

		cartArticlePush() {
			this.$store.dispatch("cart/cartArticleAdd", {
				...this.article,
				...this.layout,
			});

			if (this.article.box_capacity) {
				if (this.article.box_capacity > 1) {
					return (this.layout = {
						amount: this.article.box_capacity,
					});
				}
			}

			this.layout = {
				amount: 1,
			};
		},

		setSlideActive(key) {
			this.ui.slideActive = key;
		},

		priceFormat(val) {
			let a = new Article();

			return a.priceFormat(val);
		},

		setArticlesRelated() {
			this.sliders.articlesRelated = this.getArticlesWhereCategoryId(
				this.article.category.id
			);
		},
	},

	computed: {
		...mapState({
			account: (state) => state.acount,
		}),

		...mapGetters(["getArticlesWhereCategoryId"]),

		Price() {
			let a = new Article(this.article);

			return a.price();
		},

		HasDiscount() {
			let a = new Article(this.article);

			return a.hasDiscount();
		},

		NetContent() {
			const a = new Article(this.article);

			return a.netContent();
		},

		Weight() {
			let a = new Article(this.article);

			let weight = a.weight();

			return weight;
		},

		Amount() {
			return this.Price * this.layout.amount;
		},
	},
};
</script>

<style lang="css" scoped>
.carousel-images-container {
	height: 80vh;
	overflow-y: scroll;
}

.carousel-images-container img {
	display: flex;
	max-width: 80% !important;
	max-height: 70px;
}

.carousel-image {
	border: 2px solid #ccc !important;
	transition: all 0.2s;
}

.carousel-image:hover {
	cursor: pointer;
	/*border-color: #0078d7 !important;*/
}

.slide-active {
	border-color: #005db9 !important;
}
</style>
